var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"event-bands"},_vm._l((_vm.bands),function(band,index){return _c('div',{key:index,staticClass:"band"},[_c('h2',[_vm._v(_vm._s(band.name))]),_c('cg-event-text',{staticClass:"text",attrs:{"text":band.description}}),_c('cg-event-links',{staticClass:"links",attrs:{"links":_vm.links(band)}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }